'use client';

import { createContext, useContext } from 'react';
type ToastContextValue = {
  showToast: (message: string, type?: 'success' | 'error' | 'info', subMessage?: string) => void;
};

export const GlobalToastContext = createContext<ToastContextValue>({
  showToast: () => {},
});

// This will be set by the ToastProvider when it mounts
let globalShowToast: (message: string, type?: 'success' | 'error' | 'info', subMessage?: string) => void = 
  () => {};

// Function to set the global toast function
export const setGlobalToastFunction = (fn: typeof globalShowToast) => {
  globalShowToast = fn;
};

// Create a toast object that mimics react-toastify's API
export const toast = {
  success: (message: string, subMessage?: string) => {
    globalShowToast(message, 'success', subMessage);
  },
  error: (message: string, subMessage?: string) => {
    globalShowToast(message, 'error', subMessage);
  },
  info: (message: string, subMessage?: string) => {
    globalShowToast(message, 'info', subMessage);
  },
  warn: (message: string, subMessage?: string) => {
    // We don't have a warning type, so use info instead
    globalShowToast(message, 'info', subMessage);
  },
  // Add any other methods from react-toastify that you use in your app
};

export default toast;